import styled from "styled-components";

export const SProjectLimitModalPricingCardsContainer = styled.div`
  max-width: 960px;
  background-color: var(--ui-01);
  border: 1px solid var(--ui-03);
  box-shadow: var(--box-shadow-light-blue-pop-elavation);
  border-radius: 12px;
`;
